import { graphql } from "@opensea/graphql"

export const TransactionReceiptFragment = graphql(`
  fragment TransactionReceipt on Receipt {
    itemReceipts {
      item {
        id
        imageUrl
      }
      quantity
    }
    failedItemReceipts {
      item {
        id
        imageUrl
      }
      quantity
    }
    totalSpent {
      pricePerToken {
        token {
          symbol
          unit
        }
      }
    }
  }
`)
